unit View.Aliquotas.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewAliquotasList = class(TForm)
    btNew: TButton;
    AliquotasDataset: TXDataWebDataSet;
    AliquotasDatasetid: TIntegerField;
    AliquotasDatasetaliado_id: TIntegerField;
    AliquotasDatasetdata_base_id: TIntegerField;
    AliquotasDatasetvalor: TFloatField;
    AliquotasDatasetlegenda: TStringField;
    AliquotasDatasetaliquota_compra: TBooleanField;
    AliquotasDatasetcodigo_interno: TIntegerField;
    AliquotasDatasetexcluido: TBooleanField;
    AliquotasDatasetinclusao: TDateTimeField;
    AliquotasDatasetalteracao: TDateTimeField;
    AliquotasDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewAliquotasList: TFViewAliquotasList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewAliquotasList }

procedure TFViewAliquotasList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewAliquotasList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewAliquotasList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewAliquotasList, AElementID, Result, @AfterCreate);
end;

procedure TFViewAliquotasList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewAliquotasList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewAliquotasList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      AliquotasDataset.Connection.Model.DefaultSchema.FindEntityType(AliquotasDataset.EntitySetName),
      AliquotasDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewAliquotasList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('aliquotas', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    AliquotasDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewAliquotasList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.aliquotas.list.pagination.info');
  btNew := TButton.Create('view.aliquotas.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.aliquotas.list.table');
  cbPageSize := TComboBox.Create('view.aliquotas.list.cbPageSize');
  edSearch := TEdit.Create('view.aliquotas.list.search');
  lcPaginator := TListControl.Create('view.aliquotas.list.pagination');
  AliquotasDataset := TXDataWebDataSet.Create(Self);
  AliquotasDatasetid := TIntegerField.Create(Self);
  AliquotasDatasetaliado_id := TIntegerField.Create(Self);
  AliquotasDatasetdata_base_id := TIntegerField.Create(Self);
  AliquotasDatasetvalor := TFloatField.Create(Self);
  AliquotasDatasetlegenda := TStringField.Create(Self);
  AliquotasDatasetaliquota_compra := TBooleanField.Create(Self);
  AliquotasDatasetcodigo_interno := TIntegerField.Create(Self);
  AliquotasDatasetexcluido := TBooleanField.Create(Self);
  AliquotasDatasetinclusao := TDateTimeField.Create(Self);
  AliquotasDatasetalteracao := TDateTimeField.Create(Self);
  AliquotasDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  AliquotasDataset.BeforeLoadDFMValues;
  AliquotasDatasetid.BeforeLoadDFMValues;
  AliquotasDatasetaliado_id.BeforeLoadDFMValues;
  AliquotasDatasetdata_base_id.BeforeLoadDFMValues;
  AliquotasDatasetvalor.BeforeLoadDFMValues;
  AliquotasDatasetlegenda.BeforeLoadDFMValues;
  AliquotasDatasetaliquota_compra.BeforeLoadDFMValues;
  AliquotasDatasetcodigo_interno.BeforeLoadDFMValues;
  AliquotasDatasetexcluido.BeforeLoadDFMValues;
  AliquotasDatasetinclusao.BeforeLoadDFMValues;
  AliquotasDatasetalteracao.BeforeLoadDFMValues;
  AliquotasDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewAliquotasList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'legenda';
      Title := 'legenda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliquota_compra';
      Title := 'aliquota_compra';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    AliquotasDataset.SetParentComponent(Self);
    AliquotasDataset.Name := 'AliquotasDataset';
    AliquotasDataset.EntitySetName := 'Aliquotas';
    AliquotasDataset.Connection := DMConnection.ApiConnection;
    AliquotasDataset.Left := 72;
    AliquotasDataset.Top := 144;
    AliquotasDatasetid.SetParentComponent(AliquotasDataset);
    AliquotasDatasetid.Name := 'AliquotasDatasetid';
    AliquotasDatasetid.FieldName := 'id';
    AliquotasDatasetid.Required := True;
    AliquotasDatasetaliado_id.SetParentComponent(AliquotasDataset);
    AliquotasDatasetaliado_id.Name := 'AliquotasDatasetaliado_id';
    AliquotasDatasetaliado_id.FieldName := 'aliado_id';
    AliquotasDatasetaliado_id.Required := True;
    AliquotasDatasetdata_base_id.SetParentComponent(AliquotasDataset);
    AliquotasDatasetdata_base_id.Name := 'AliquotasDatasetdata_base_id';
    AliquotasDatasetdata_base_id.FieldName := 'data_base_id';
    AliquotasDatasetdata_base_id.Required := True;
    AliquotasDatasetvalor.SetParentComponent(AliquotasDataset);
    AliquotasDatasetvalor.Name := 'AliquotasDatasetvalor';
    AliquotasDatasetvalor.FieldName := 'valor';
    AliquotasDatasetvalor.Required := True;
    AliquotasDatasetlegenda.SetParentComponent(AliquotasDataset);
    AliquotasDatasetlegenda.Name := 'AliquotasDatasetlegenda';
    AliquotasDatasetlegenda.FieldName := 'legenda';
    AliquotasDatasetlegenda.Required := True;
    AliquotasDatasetlegenda.Size := 255;
    AliquotasDatasetaliquota_compra.SetParentComponent(AliquotasDataset);
    AliquotasDatasetaliquota_compra.Name := 'AliquotasDatasetaliquota_compra';
    AliquotasDatasetaliquota_compra.FieldName := 'aliquota_compra';
    AliquotasDatasetaliquota_compra.Required := True;
    AliquotasDatasetcodigo_interno.SetParentComponent(AliquotasDataset);
    AliquotasDatasetcodigo_interno.Name := 'AliquotasDatasetcodigo_interno';
    AliquotasDatasetcodigo_interno.FieldName := 'codigo_interno';
    AliquotasDatasetcodigo_interno.Required := True;
    AliquotasDatasetexcluido.SetParentComponent(AliquotasDataset);
    AliquotasDatasetexcluido.Name := 'AliquotasDatasetexcluido';
    AliquotasDatasetexcluido.FieldName := 'excluido';
    AliquotasDatasetinclusao.SetParentComponent(AliquotasDataset);
    AliquotasDatasetinclusao.Name := 'AliquotasDatasetinclusao';
    AliquotasDatasetinclusao.FieldName := 'inclusao';
    AliquotasDatasetalteracao.SetParentComponent(AliquotasDataset);
    AliquotasDatasetalteracao.Name := 'AliquotasDatasetalteracao';
    AliquotasDatasetalteracao.FieldName := 'alteracao';
    AliquotasDatasetexclusao.SetParentComponent(AliquotasDataset);
    AliquotasDatasetexclusao.Name := 'AliquotasDatasetexclusao';
    AliquotasDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := AliquotasDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    AliquotasDataset.AfterLoadDFMValues;
    AliquotasDatasetid.AfterLoadDFMValues;
    AliquotasDatasetaliado_id.AfterLoadDFMValues;
    AliquotasDatasetdata_base_id.AfterLoadDFMValues;
    AliquotasDatasetvalor.AfterLoadDFMValues;
    AliquotasDatasetlegenda.AfterLoadDFMValues;
    AliquotasDatasetaliquota_compra.AfterLoadDFMValues;
    AliquotasDatasetcodigo_interno.AfterLoadDFMValues;
    AliquotasDatasetexcluido.AfterLoadDFMValues;
    AliquotasDatasetinclusao.AfterLoadDFMValues;
    AliquotasDatasetalteracao.AfterLoadDFMValues;
    AliquotasDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
